export default {
  ISO8601: "YYYY-MM-DDTHH:mm:ssZ",
  DB_ENTRY: "YYYY-MM-DD HH:mm:ss",
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm",
  DISPLAY_DATE: "DD-MM-YYYY",
  DISPLAY_DATE_WITH_DAY: "dddd D MMMM YYYY",
  NEW_DISPLAY_DATE: "DD MMMM yyyy",
  NEW_DISPLAY_DATETIME: "DD MMMM yyyy HH:mm",
  DISPLAY_DATETIME: "DD-MM-YYYY HH:mm",
  DISPLAY_DATETIME_WITH_SECONDS: "DD-MM-YYYY HH:mm:ss",
  DISPLAY_DATETIME_WITH_DAY: "dddd DD-MM-YYYY HH:mm",
  DISPLAY_TIME: "HH:mm",
};
